import { Link } from "react-router-dom";

const FSS_LOGO =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_fire-cctv-access/artifacts/gk3cytkj_FSS%20LOGO.png";

export function FSSLogo({ className = "h-11 w-auto" }) {
  return (
    <Link to="/" className="flex items-center gap-3" data-testid="fss-logo-link">
      <img
        src={FSS_LOGO}
        alt="Fire Safety Systems — FSS"
        className={className}
        loading="eager"
      />
      <span className="hidden md:flex flex-col leading-tight">
        <span className="font-display text-base font-bold tracking-tight text-slate-900">
          FSS
        </span>
        <span className="text-[10px] tracking-[0.16em] uppercase text-slate-500 font-semibold">
          Facilities and Safety Systems
        </span>
      </span>
    </Link>
  );
}

export default FSSLogo;
